import { Box } from "@mui/material";
import { useTenantAssets } from "../../contexts/TenantAssetsContext";

export default function Welcome() {
  const { assets, isLoading } = useTenantAssets();
  const LoaderIcon = assets?.loaderIcon;

  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          position: "absolute",
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: 10,
          backgroundColor: "text.bodyBg",
        }}
      >
        {LoaderIcon && <LoaderIcon />}
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          position: "absolute",
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: 10,
        }}
      >
        <div className="welcome-loader"></div>
      </Box>
    </>
  );
}
